import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ApiV6Service } from '@service/apiv6.service';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MessagesService } from '@core/_services/messages.service';
import { ListboxModule } from 'primeng/listbox';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { InternalModule } from '@documalis/internal.module';
import { DownloadService } from '@service/download.service';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';
import {FormsModule} from "@angular/forms";
import {NgClass} from "@angular/common";
import { lastValueFrom } from 'rxjs';
import { getVisibiliyValue } from '@core/_utils/tools.utils';
import { ExpDocks_, ExpRequests_, ExpResults_ } from '@documalis/_const/const';

@Component({
  selector: 'page-export',
  standalone: true,
  imports: [
    TranslateModule,
    ListboxModule,
    ButtonModule,
    TableModule,
    InternalModule,
    FileUploadModule,
    FormsModule,
    NgClass
  ],
  templateUrl: './page-export.component.html',
  styleUrl: './page-export.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class PageExportComponent implements OnInit {
  public selectedRows: any[];
  public exportList: any[];
  public itemImport: [];
  public typeImpExp: string = '';
  public browseLabel = '';
  public listColumns = [];
  public selectedItem: any;
  public filename: string;

  @ViewChild('fileUploader') public fileUploader: FileUpload;

  constructor(
    private api: ApiV6Service,
    public menu: MenuServiceInt,
    protected messageService: MessagesService,
    private _translate: TranslateService,
    private downloadService: DownloadService,
) {
    this.menu.display = true;
    this.exportList = [];
    this.itemImport = [];
    this.listColumns = [];
    this.selectedRows = [];
}

  ngOnInit(): void {
    this.browseLabel = this._translate.instant('File_Sel_1');
    this.getExportList();
  }

  private getExportList() {
    this.exportList.push({ name: this._translate.instant('Menu_Param_Docks_Pos'), value: 'docks' });
    this.exportList.push({ name: this._translate.instant('Export_Req'), value: 'requests' });
    this.exportList.push({ name: this._translate.instant('Export_Res'), value: 'results' });
  }

  public onExportClick($event) {
    if ($event.option !== null) {
      this.selectedRows = [];
      this.itemImport = [];
      this.filename = '';
      this.typeImpExp = $event.option.value;
      this.getColumnList(this.typeImpExp);
    }
  }

  public async onClickImport() {
    switch (this.typeImpExp) {
      case 'docks':
        await this.doImport('importparamdocks');
        break;
      case 'requests':
        await this.doImport('importparamrequests');
        break;
      case 'results':
        await this.doImport('importparamresults');
        break;        
    } 
  }

  private async doImport(aAction) {
    const wRequest = {
      data: JSON.stringify(this.selectedRows)
    }
    try {
      await lastValueFrom(this.api.execUrlAction(aAction, wRequest));
      this.messageService.addSuccess(this._translate.instant('Import_OK'));
    } catch (error) {
      this.messageService.addErrorMsg(this._translate.instant('Update_KO'));
    }   
  }

  public onFileSelect(event: any) {  
    try {
      const file = event.files[0];
      if (this.verifyFileType(this.typeImpExp, file.name) === false) {
        this.itemImport = [];
        this.fileUploader.clear()
        const msgError = this._translate.instant('Imp_JSONKO');
        this.messageService.addErrorMsg(msgError);
        throw new Error(msgError);
      }
      const reader = new FileReader();
      reader.readAsText(file, 'UTF-8');
      reader.onerror = (error) => {
          console.log(error);
      }
      reader.onload = () => {
          try {
            this.itemImport = JSON.parse(reader.result as string);
            if (Array.isArray(this.itemImport) === false) {
              const msgError = this._translate.instant('Imp_JSONKO');
              this.messageService.addErrorMsg(msgError);
              throw new Error(msgError);
            }
            this.itemImport = this.formatImport(this.itemImport, this.typeImpExp);
            
          } catch (error) {
            this.itemImport = [];
            console.log('onFileSelect reader', error);
          } finally {
            this.filename = file.name;
            this.fileUploader.clear();
          }       
      }      
    } catch (error) {
      console.log('onFileSelect', error);
    }
  }

  public async doExport($event) {
    switch ($event) {
      case 'docks':
      case 'requests':
      case 'results':
        await this.downloadService.doExport($event);
        break;
    }
  }

  private formatImport(itemImport, aExportType) {
    switch (aExportType) {
      case 'docks':
        return itemImport;
      case 'requests':
      case 'results':
        itemImport.map((item) => {
          item.visibilityLabel = getVisibiliyValue(item);
        })
        return itemImport;
    }
  }

  private verifyFileType(aExportType, file) {
    switch (aExportType) {
      case 'docks':
        return file.slice(0, ExpDocks_.length) === ExpDocks_;
      case 'requests':
        return file.slice(0, ExpRequests_.length) === ExpRequests_;
      case 'results':
        return file.slice(0, ExpResults_.length) === ExpResults_;
      default:
        return false;
    }    
  }

  public clickcolck(event) {
    event.stopPropagation();
  }

  private getColumnList(aExportType) {
    this.listColumns = [];
    switch (aExportType) {
      case 'docks':
        this.listColumns = [
          {header: this._translate.instant('ImpDockMod'), field: 'name', type: 'String'},
          {header: this._translate.instant('ImpDockModTyp'), field: 'docktype', type: 'String'},
        ];
        break;
      case 'requests':
      case 'results':        
        this.listColumns = [
          { header: this._translate.instant('Name'), field: 'label' },
          { header: this._translate.instant('Visibility'), field: 'visibilityLabel' },
          { header: this._translate.instant('Desc'), field: 'description' },
        ];
        break;
    }
  }
}
